// JavaScript Document
(function($) {

	'use strict';

    var $finder = $('#alert-sys-finder'),
        referrer =  document.referrer,
        windowWidth = $(window).width();

    function goToNextStep()
    {

        $finder.find('.continue-btn button').removeClass('loading').children('img.loader').hide();

        var qNum = $finder.find('.question-container.active').index() + 2;

        if (qNum < 7)
            $finder.find('#question-count #count').text(qNum);

        if (!$finder.find('.question-container').last().hasClass('active')) {

            $finder.find('.finder-footer button').removeClass(function (index, className) {
                return (className.match(/\bstep-\d+/g) || []).join(' ');
            }).addClass('step-'+qNum);

        }

        if (qNum > 1) {

            $finder.find('#previous-link a').html('previous').attr('href', $finder.find('#previous-link a').attr('date-url')).show();

        }
        else {

            $finder.find('#previous-link a').html('previous').attr('href', referrer).show();

        }

        if (windowWidth <= 767) {

            if ($finder.hasClass('first-step-active') && qNum === 2) {

                $finder.find('.qa-why').first().fadeIn().addClass('active');

            }
            else {

                $finder.find('.qa-why.active').fadeOut().removeClass('active').next('.qa-why').fadeIn().addClass('active');

            }

        }
        else {

            $finder.find('.question-container.active').find('.qa-why').hide();

        }

        if ($finder.find('.question-container:nth-last-child(2)').hasClass('active')) {

            $finder.find('.finder-footer button').fadeOut().html('Finish<i><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="#fff" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"/></svg></i><img class="loader" src="/app/themes/senior-living/alert-system-finder/img/ajax-loader.svg" />').stop().fadeIn();

        }

        if (!$finder.find('.question-container').last().hasClass('active')) {

            var $currentHeight = $finder.find('.question-container.active').outerHeight();
            var $height = $finder.find('.question-container.active').next('.question-container').outerHeight();
            var $nextContainerHeight = ($('#alert-sys-finder').outerHeight(true) - 50) - $currentHeight + $height;

            $('#finder-bg').animate({height:$nextContainerHeight},{duration: 300, queue: false});

            if ($height < 200)
                $height = 200;

            $finder.find('#finder-question-container').css({'height': $currentHeight, 'min-height': 0}).animate({height:$height},{duration: 300, queue: false, complete: function() {

                    console.log('adjusted height');

                    $(this).css({height: 'auto', 'min-height': $height});

                },

            });

            $finder.find('.question-container.active').fadeOut().removeClass('active').next('.question-container').fadeIn().addClass('active');

        }
        else {

            $finder.find('.continue-btn button').addClass('loading').children('img.loader').show();

            var values = $finder.find('.question-container input[type="radio"]:checked').serialize()

            $.get(window.ajax_object.ajax_url,{action: 'get_finder_results', data: values}, function(data) {

                $finder.children('#replace-container').animate({opacity: 0}, 500, function() {

                    $finder.find('.continue-btn button').addClass('loading').children('img.loader').show();

                    $finder.find('p.h2').text($finder.find('p.h2').text()+': Results');

                    $(this).parent().addClass('results');

                    $(this).empty().html(data).stop().animate({opacity: 1}, {duration: 300, queue: false});

                    $('#finder-bg').animate({height:$finder.outerHeight(true) - 50},{duration: 300, queue: false});

                });

            }, 'json');

        }

    }

    function goBackOneStep($this)
    {

        var qNum = $finder.find('.question-container.active').index();

        $finder.find('.finder-footer button').removeClass(function (index, className) {
            return (className.match(/\bstep-\d+/g) || []).join(' ');
        }).addClass('step-'+qNum);

        if (qNum === 1 && $finder.hasClass('first-step-active')) {

            $finder.removeClass('has-questions');
            $this.hide();

        }
        else {

            if (qNum === 2) {

                if ($finder.hasClass('first-step-active')) {

                    $this.html('previous').attr('href', $this.attr('date-url'));

                }
                else {

                    $this.html('previous').attr('href', referrer);

                }

            }
            else if(qNum < 2) {

                window.location.href = $this.attr('href');

            }
            else {

                $this.html('previous').attr('href', $this.attr('date-url'));

            }

        }

        if(qNum >= 2 || $finder.hasClass('first-step-active')) {

            $finder.find('#question-count #count').text(qNum);

            var $currentHeight = $finder.find('.question-container.active').outerHeight();
            var $height = $finder.find('.question-container.active').prev('.question-container').outerHeight();
            var $nextContainerHeight = ($('#alert-sys-finder').outerHeight(true) - 50) - $currentHeight + $height;

            if ($height < 200)
                $height = 200;

            $finder.find('.question-container.active').find('.qa-why').hide();

            $('#finder-bg').animate({height:$nextContainerHeight},{duration: 300, queue: false});

            $finder.find('#finder-question-container').animate({height:$height},{duration: 300, queue: false},function() {

                $(this).css({height: 'auto', 'min-height': $height});

            });

            $finder.find('.question-container.active').fadeOut().removeClass('active').prev('.question-container').fadeIn().addClass('active');

            if (windowWidth <= 767) {

                $finder.find('.qa-why.active').fadeOut().removeClass('active').prev('.qa-why').fadeIn().addClass('active');

            }

        }

        if ($finder.find('.question-container:nth-last-child(2)').hasClass('active')) {

            $finder.find('.finder-footer button').fadeOut().html('Next<i><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="#fff" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"/></svg></i><img class="loader" src="/app/themes/senior-living/alert-system-finder/img/ajax-loader.svg" />').stop().fadeIn();

        }

    }

    function getHashFilter()
    {

        var matches = location.hash.match(/c=([^&]+)/i);

        var hashFilter = matches && matches[1];

        return hashFilter && decodeURIComponent(hashFilter);

    }

    function updateQuestions($person) {
        $person = $person.toLowerCase();

        var
            $past_tense_yes = $person == 'myself'
                ? 'I have' : ($person == 'Mother'
                ? 'she has' : ($person == 'Father'
                ? 'he has' : 'they have')),
            $present_tense_yes = $person == 'myself'
                ? 'I do' : ($person == 'mother'
                ? 'she does' : ($person == 'father'
                ? 'he does' : 'they do')),
            $past_tense_no = $person == 'myself'
                ? 'I haven\'t' : ($person == 'Mother'
                ? 'she hasn\'t' : ($person == 'Father'
                ? 'he hasn\'t' : 'they haven\'t')),
            $present_tense_no = $person == 'myself'
                ? 'I don\'t' : ($person == 'mother'
                ? 'she doesn\'t' : ($person == 'father'
                ? 'he doesn\'t' : 'they don\'t')),
            $past_tense_answers = {
                'yes': `Yes ${$past_tense_yes}`,
                'no': `No ${$past_tense_no}`,
            },
            $present_tense_answers = {
                'yes': `Yes ${$present_tense_yes}`,
                'no': `No ${$present_tense_no}`,
            },
            $question_4_container = $('#question-4').find('.finder-answers'),
            $question_5_container = $('#question-5').find('.finder-answers');

        Object.keys($present_tense_answers).forEach((value) => {
            $question_4_container.find(`input[value=${value}]`).prev().html($present_tense_answers[value]);
        });

        Object.keys($past_tense_answers).forEach((value) => {
            $question_5_container.find(`input[value=${value}]`).prev().html($past_tense_answers[value]);
        });
    }

    function getQuestions()
    {

        var $person = getHashFilter();

        if (typeof $person !== 'undefined' && $person !== null ) {

            $.get(window.ajax_object.ajax_url, {action: 'get_alert_questions', person: $person}, function(data) {

                $.each(data, function(container, question) {

                    $(container).find('.finder-question .question').empty().html(question);

                });

                $finder.find('#question-1 .finder-answers input:radio[value="'+$person+'"]').attr('checked','checked');

                $finder.addClass('has-questions').animate({opacity: 1}, 500);

                $('#page-loader').hide();

            }, 'json');

            updateQuestions($person);

        }
        else {

            if (!$finder.hasClass('first')) {

                $finder.find('#question-1').addClass('active');
                $finder.find('#question-2').removeClass('active');
                $finder.find('#question-count #count').text('1');
                $finder.find('#previous-link a').hide();
                $finder.addClass('first-step-active mt-md-5').animate({opacity: 1}, 500);

                $finder.find('.finder-footer button').removeClass(function (index, className) {
                    return (className.match(/\bstep-\d+/g) || []).join(' ');
                }).addClass('step-1');

                $('#page-loader').hide();

            }

        }

    }

    function setupNumericInput(element, allowDecimal, errorCallback) {
        element.addEventListener('keypress', function(e) {
            const key = e.which || e.keyCode;
            const allowedKeys = [8, 9, 13, 35, 36, 37, 39, 46]; // Backspace, Tab, Enter, End, Home, Left arrow, Right arrow, Delete

            if (allowedKeys.indexOf(key) !== -1) {
                return true;
            }

            if (key < 48 || key > 57) {
                e.preventDefault();
                return false;
            }

            if (!allowDecimal && key === 46) {
                e.preventDefault();
                return false;
            }
        });

        element.addEventListener('paste', function(e) {
            const pastedText = (e.clipboardData || window.clipboardData).getData('text');
            if (!/^\d+$/.test(pastedText)) {
                e.preventDefault();
            }
        });

        element.addEventListener('blur', function() {
            if (this.value && !/^\d+$/.test(this.value)) {
                errorCallback.call(this);
            }
        });
    }

    $(function() {

        getQuestions();

            const zipCodeInput = document.getElementById('zip_code');

            setupNumericInput(zipCodeInput, false, function() {
                this.value = '';
                this.focus();
            });

        $(window).on('resize', function() {

            var windowWidth = $(window).width();

            if (windowWidth > 767) {

                if ($('#qa-why-mobile .qa-why').length) {

                    $('#qa-why-mobile .qa-why').each(function() {

                        var $id = $(this).attr('id').replace('qa-', '');

                        if (!$('#question-'+$id+' .qa-why').length) {

                            $(this).removeClass('active').css('opacity',0).insertAfter('#question-'+$id+' .qa-container');

                        }

                    });

                }

            }
            else {

                var $id = $finder.find('.question-container.active').attr('id').replace('question-', '');

                $finder.find('.question-container .qa-why').each(function() {

                    $(this).appendTo('#qa-why-mobile');

                });

                if (!$finder.hasClass('first-step-active')) {

                    $finder.find('#qa-why-mobile').find('#qa-'+$id).first().addClass('active').css('opacity',1);

                }

            }

        });

        if ($('#finder-bg').length) {

            $('#finder-bg').width($(window).width());
            $('#finder-bg').height($('#alert-sys-finder').outerHeight(true) - 50);
            $('#finder-bg').css({'left': $('#alert-sys-finder').offset().left * -1});

            $(window).on('resize', function() {

                $('#finder-bg').width($(window).width());
                $('#finder-bg').animate({height:$('#alert-sys-finder').outerHeight(true) - 50},300);
                $('#finder-bg').css({'left': $('#alert-sys-finder').offset().left * -1});

            });

        }

        $finder.find('#previous-link a').on('click', function(e) {

            e.preventDefault();

            goBackOneStep($(this));

        });

        if (windowWidth <= 767) {

            $finder.find('.question-container .qa-why').each(function() {

                $(this).appendTo('#qa-why-mobile');

            });


            if (!$finder.hasClass('first-step-active')) {

                $finder.find('#qa-why-mobile .qa-why').first().addClass('active');

            }

        }

        $finder.on('click', '.finder-question i', function() {

            var whyContainer = $(this).parents('.inner-container').children('.qa-why');

            if (whyContainer.is(':hidden')) {

                whyContainer.stop().addClass('active').fadeIn(500);

            }
            else {

                whyContainer.stop().removeClass('active').fadeOut(500);

            }

        });

        $finder.find('.continue-btn button').on('click', function(e) {

            e.preventDefault();

            var
                checkedValue = $('.question-container.active input[type="radio"]:checked').val(),
                textInput = $('.question-container.active input[type="text"]'),
                textValue = textInput ? textInput.val() : 0;

            // check zip code
            if (!checkedValue && textValue && textValue.length) {
                if ($('.question-container.active').attr('id') == 'question-6') {
                    const request_attributes = [
                        window.ajax_object.ajax_url,
                        {
                            'action': 'asf_validate_zipcode',
                            'zip': textValue,
                        },
                        (data) => {
                            data = JSON.parse(data);
                            checkedValue = data.isValid ? data.isValid : false;

                            if (checkedValue) {
                                $finder.find('#warning').hide();
                                executeViewUpdate(checkedValue);
                            } else {
                                $finder.find('#warning').show();
                            }
                        },
                    ];

                    $.post(...request_attributes);
                }
            // check radio input
            } else if (checkedValue) {
                $finder.find('#warning').hide();
                executeViewUpdate(checkedValue);
            // fail
            } else {
                $finder.find('#warning').show();
            }

        });

        function executeViewUpdate(checkedValue)
        {
            if ($finder.hasClass('first')) {

                if (checkedValue) {

                    window.location.href = '/medical-alert-system-finder/#c='+encodeURIComponent(checkedValue);

                }

            } else {

                if (checkedValue) {

                    $finder.find('#warning').hide();

                    if ($finder.hasClass('first-step-active') && !$finder.hasClass('has-questions')) {

                        $finder.find('.continue-btn button').addClass('loading').children('img.loader').show();

                        $.get(window.ajax_object.ajax_url, {action: 'get_alert_questions', person: checkedValue}, function(data) {

                            $.each(data, function(container, question) {

                                $(container).find('.finder-question .question').empty().html(question);

                            });

                            $finder.addClass('has-questions');

                            goToNextStep();

                        }, 'json');

                        updateQuestions(checkedValue)

                    }
                    else {

                       goToNextStep();

                    }

                }
                else {

                    $finder.find('#warning').show();

                }

            }
        }

    });


})(jQuery);
